import AppName from "./application_name";
import TitleApplication from "./app_name";
import getUrlApi from "./geturlapi";

// Check App Browser Host
const checkUrlHost = window.__RUNTIME_CONFIG__.REACT_APP_BROWSER_HOST === true;

// Base URL
const baseUrl = checkUrlHost
  ? getUrlApi()
  : window.__RUNTIME_CONFIG__.REACT_APP_API_HOST;

// Application Name
const applicationStatus = window.__RUNTIME_CONFIG__.NODE_ENV;
const appName = AppName(applicationStatus);

export { baseUrl, applicationStatus, appName, TitleApplication };
